import { ApiProperty } from '@nestjs/swagger';
import { Exclude, Expose } from 'class-transformer';
import { RepairTypeEnum } from '../../repair/enums/repair-type.enum';
import { RepairPayablesSheetInterface } from '../interfaces/repair-payables-sheet.interface';

@Exclude()
export class RepairPayablesSheetDto implements RepairPayablesSheetInterface {
  @Expose()
  @ApiProperty({
    title: 'regionId',
  })
  regionId!: string;

  @Expose()
  @ApiProperty({
    title: 'regionName',
  })
  regionName!: string;

  @Expose()
  @ApiProperty({
    title: 'supervisorFirstName',
  })
  supervisorFullNames!: string;

  @Expose()
  @ApiProperty({
    title: 'builderName',
  })
  builderName!: string;

  @Expose()
  @ApiProperty({
    title: 'subdivisionName',
  })
  subdivisionName!: string;

  @Expose()
  @ApiProperty({
    title: 'supplierName',
  })
  supplierName!: string;

  @Expose()
  @ApiProperty({
    title: 'jobLot',
  })
  jobLot!: string;

  @Expose()
  @ApiProperty({
    title: 'Job Block',
  })
  jobBlock!: string;

  @Expose()
  @ApiProperty({
    title: 'Community Phase',
  })
  jobCommunityPhase!: string;

  @Expose()
  @ApiProperty({
    title: 'repairType',
  })
  repairType!: RepairTypeEnum;

  @Expose()
  @ApiProperty({
    title: 'repairDescription',
  })
  repairDescription!: string;

  @Expose()
  @ApiProperty({
    title: 'repairDate',
  })
  repairDate!: Date;

  @Expose()
  @ApiProperty({
    title: 'Repair Payment Date',
  })
  repairPaymentDate!: Date;

  @Expose()
  @ApiProperty({
    title: 'description',
  })
  description!: string;

  @Expose()
  @ApiProperty({
    title: 'calculateCost',
  })
  calculateCost!: number | null;

  @Expose()
  @ApiProperty({
    title: 'currentCost',
  })
  currentCost!: number | null;

  @Expose()
  @ApiProperty({
    title: 'check',
  })
  check!: string;

  @Expose()
  @ApiProperty({
    title: 'paidDate',
  })
  paidDate!: Date | null;

  @Expose()
  @ApiProperty({
    title: 'isBackdated',
  })
  isBackdated!: boolean;

  @Expose()
  @ApiProperty({
    title: 'contractorId',
  })
  contractorId!: string;

  @Expose()
  @ApiProperty({
    title: 'contractorName',
  })
  contractorName!: string;

  @Expose()
  @ApiProperty({
    title: 'status',
  })
  status!: string;

  @Expose()
  @ApiProperty({
    title: 'id',
  })
  id!: string;

  @Expose()
  @ApiProperty({
    title: 'createdAt',
  })
  createdAt!: Date;

  @Expose()
  @ApiProperty({
    title: 'updatedAt',
  })
  updatedAt!: Date;

  @Expose()
  @ApiProperty({
    title: 'jobId',
  })
  jobId!: string;

  @Expose()
  @ApiProperty({
    title: 'subdivisionId',
  })
  subdivisionId!: string;

  @Expose()
  @ApiProperty({
    title: 'builderId',
  })
  builderId!: string;

  @Expose()
  @ApiProperty({
    title: 'repairId',
  })
  repairId!: string;

  @ApiProperty({
    type: 'string',
    format: 'uuid',
    title: 'Created ByUser ID',
  })
  @Expose()
  createdById!: string;

  @ApiProperty({
    type: 'string',
    format: 'uuid',
    title: 'Created By (User) Name',
  })
  @Expose()
  createdByName!: string;

  @Expose()
  @ApiProperty({
    title: 'supervisorUserId',
  })
  supervisorUserIds!: string;

  // used only for permissinos
  supervisorFieldCoordinatorUserId!: string | null;
}
